<template>
  <div class="input mt-3 md:mt-6 relative" :key="randomKey">
    <label v-if="type==='tel'" class="relative">
      <input
        class="border-iphone"
        :value="value ? value : in_focus ? masked : ''"
        v-mask="masked"
        :class="[{ 'focus': in_focus, 'error': error}, inputClasses]"
        @input="changedValue($event.target.value); phone_number = $event.target.value; setCarret()"
        :readonly="editable"
        :type="type"
        @focus="handler"
        @click.stop.prevent
        @blur="on_blur"
        :max="type === 'number' ? max: ''"
        :min="type === 'number' ? min: ''"
        ref="phone"
        :style="`min-height:${minHeight}px`"
      />
      <span
          class="placeholder whitespace-no-wrap"
          :class="{ 'focus': in_focus}"
      >{{ placeholder }}<span v-show="fieldRequired" class="ml-1 text-brand-red text-xs">*</span></span>
    </label>
    <label :for="id" v-else class="relative">
      <input
          :id="id"
          :name="name"
          :autocomplete="autocomplete"
         ref="text"
        :value="value"
        class="border-iphone"
        :class="[{ 'focus': in_focus, 'error': error}, inputClasses]"
        @change="$emit('input', $event.target.value), line=$event.target.value;"
        :readonly="editable"
        :type="type"
        @focus="handler"
        @click.stop.prevent
        @blur="on_blur"
        :max="type === 'number' ? max: ''"
        :min="type === 'number' ? min: ''"
         :style="`min-height:${minHeight}px`"
      />
      <span
          class="placeholder whitespace-no-wrap"
          :class="{ 'focus': in_focus, 'focus-always': alwaysFocused}"
      >{{ placeholder }}
      <span v-show="fieldRequired" class="ml-1 text-brand-red text-xs">*</span></span>
    </label>

    <div v-if="error" class="flex flex-row absolute mt-1">
      <img src="../assets/SVG/error_notification.svg" alt="error"/>
      <span class="pl-1 text-brand-red font-normal text-uxs error">{{ error }}</span>
    </div>
  </div>
</template>


<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'mozgo-inp',
  directives: { mask },
  props: {
    placeholder: {
      type: String,
      default: 'text',
    },
    value: {
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    error: {
      type: String,
    },
    max: {
      type: Number,
    },
    min: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    alwaysFocused: {
      type: Boolean,
      default: false,
    },
    fieldRequired: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    autocomplete: {
      type: String,
    },
    for: {
      type: String,
    },
    minHeight: {
      type: Number,
      default: 40,
    },
    inputClasses: {
      type: String,
      default: '',
    },
  },
  mounted() {
    if (this.value) (this.in_focus = true);

    this.editable = this.readonly;
  },

  data() {
    return {
      in_focus: false,
      line: '',
      editable: false,
      // hidden_holer: false,
      masked: '',
      phone_number: '',
      randomKey: '',
    };
  },
  computed: {
    city() {
      if (this.$store.getters.authUserCity) {
        return this.$store.getters.authUserCity;
      }
      return this.$store.getters.cityProps;
    },

  },
  created() {
    const uuidv4 = require('uuid/v4');
    this.randomKey = uuidv4();

    if (this.type === 'number' && this.max) {
      if (this.value > this.max) this.$emit('input', this.max);
    }
    this.masked = this.city.phone_code ? `+${this.city.phone_code}(###)###-##-##` : '+7(###)###-##-##';
  },
  watch: {
    value() {
      if (!this.value) {
        this.in_focus = false;
        return;
      }
      this.in_focus = true;
    },
    readonly() {
      this.editable = this.readonly;
    },
    phone_number() {
      if (this.type !== 'tel') return;
      if (this.type === 'tel' && this.value.length <= 5) {
        if (this.city.phone_code === '49') this.masked = `+${this.city.phone_code}(###)###-##-####`; // Костыль для Германии
        if (this.city.phone_code === '375') {
          this.masked = `+${this.city.phone_code}(##)###-##-##`;
        } // Костыль для Беларуси
        if (this.city.phone_code === '998') {
          this.masked = `+${this.city.phone_code}(##)###-##-##`;
        } // Костыль для Узбекистана
        if (this.city.phone_code === '62') {
          this.masked = `+${this.city.phone_code}(###)########`;
        } // Костыль для Бали
      }
      if (this.phone_number.length <= this.city.phone_code.length + 2) {
        this.$emit('input', `+${this.city.phone_code}(`);
      }
    },
  },
  methods: {
    changedValue(phone) {
      const repPhone = phone.replace(/[^0-9]/gi, '');
      if (repPhone) {
        this.$emit('input', `+${repPhone}`);
        this.line = phone;
      } else {
        this.$emit('input');
        this.line = phone;
      }
    },
    handler() {
      this.in_focus = true;
    },
    on_blur() {
      this.$emit('blur');
      if (this.value) return;
      this.in_focus = false;
    },
    onTextArea() {
      const el = this.$refs.text;

      setTimeout(() => {
        el.style.cssText = 'height:auto; padding:0';
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = `height:${el.scrollHeight}px`;
      }, 0);
    },
    setCarret() {
      const position = this.$refs.phone.value.length;
      this.$nextTick(() => {
        this.$refs.phone.focus();
        this.$refs.phone.selectionStart = position;
        this.$refs.phone.selectionEnd = position;
      });
    },
  },

};
</script>

<style scoped>
input {
  @apply relative w-full  border-brand-light outline-none  pt-3 font-bold font-bold text-sm px-1 text-main-text;
  border-bottom: 1px solid #979797;
}

input.error {
  border-bottom: 1px solid #979797;
}

.placeholder {
  @apply absolute pointer-events-none font-bold px-1 text-sm;
  transition: all 0.3s;
  top: 0;
  color: #979797;
  left: 0;
}

.placeholder.focus {
  @apply text-additional-text text-mxs;
  top: -15px;
}

input:focus {
  border-bottom: 1px solid #dd006f;
}

.focus-always {
  @apply text-additional-text text-mxs;
  top: -15px;
}

.error {
  left: 0;
  top: 100%;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

@media only screen and (min-width: 319px) and (max-width: 330px) {
  .iphone-padding-mt-5 {
    margin-top: 0.7rem !important;
  }
}
</style>
